import { render, staticRenderFns } from "./ReviewPowerInfo.vue?vue&type=template&id=395f7c4d&"
import script from "./ReviewPowerInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewPowerInfo.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('395f7c4d')) {
      api.createRecord('395f7c4d', component.options)
    } else {
      api.reload('395f7c4d', component.options)
    }
    module.hot.accept("./ReviewPowerInfo.vue?vue&type=template&id=395f7c4d&", function () {
      api.rerender('395f7c4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewPowerInfo/ReviewPowerInfo.vue"
export default component.exports